import { GLFactorService } from "../gl/gl-factor.service";
// import { getFactorByCode } from "../../../_store/helpers";
// import { store } from "../../../_store";

GLFactorService

const BankFeeSettings = {
  async getDefaultSettings() {
    let bankFeeSettings = {
      GLAccount: undefined,
      Branch: undefined,
      Division: undefined,
      Comment: undefined,
    }

    await GLFactorService.getByCode(44, ["Code", "GLChartCode"]).then((res) => {
      if (res.data.value[0].GLChartCode) {
        bankFeeSettings.GLAccount = `${res.data.value[0].GLChartCode}`;
      }
    });

    // await store.dispatch("screenFactors/getFactors", [666, 667, 668,]).then(() => {
    //   bankFeeSettings.Branch = getFactorByCode(666).Factorc;
    //   bankFeeSettings.Division = getFactorByCode(667).Factorc;
    //   bankFeeSettings.Comment = getFactorByCode(668).Factorc;
    // });

    return bankFeeSettings;
  }
}

export { BankFeeSettings }